import Serializer from 'umg-ember-backend/serializers/application';

export default class AssetDownloadLinkSerializer extends Serializer {
  attrs = {
    asset: 'assetId',
    format: 'formatId',
  };
}
